import { useState } from "react";
import { ADMIN_SECRET } from "./adminUtils";
import BookingsTab from "./tabs/BookingsTab";
import StudentsPassesTab from "./tabs/StudentsPassesTab";
import CalendarTab from "./tabs/CalendarTab";
import MerchTab from "./tabs/MerchTab";
import ReportsTab  from "./tabs/ReportsTab";
import CheckInTab  from "./tabs/CheckInTab";
import SettingsTab from "./tabs/SettingsTab";
import "./admin-base.css";
import "./admin-layout.css";
import "./admin-controls.css";
import "./admin-responsive.css";

function PasswordGate({ onSuccess }) {
  const [pw, setPw]       = useState("");
  const [error, setError] = useState(false);
  const submit = () => {
    if (pw === ADMIN_SECRET) onSuccess();
    else { setError(true); setPw(""); }
  };
  return (
    <div className="adm-gate">
      <div className="adm-gate-card">
        <div className="adm-gate-logo">⚙</div>
        <h1 className="adm-gate-title">Admin Dashboard</h1>
        <p className="adm-gate-sub">Iyengar Yoga St. Petersburg</p>
        <input autoFocus type="password"
          className={`adm-gate-input ${error ? "input-error" : ""}`}
          placeholder="Password" value={pw}
          onChange={e => { setPw(e.target.value); setError(false); }}
          onKeyDown={e => e.key === "Enter" && submit()}
        />
        {error && <p className="adm-gate-error">Incorrect password.</p>}
        <button className="adm-btn adm-btn--primary" onClick={submit}>Enter</button>
      </div>
    </div>
  );
}

export default function Admin() {
  const [authed, setAuthed] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("admin") === "true";
  });
  const [tab, setTab] = useState("bookings");

  if (!authed) return <PasswordGate onSuccess={() => setAuthed(true)} />;

  return (
    <div className="adm-wrap">
      <div className="adm-header">
        <div className="adm-header-left">
          <span className="adm-header-logo">⚙</span>
          <div>
            <h1 className="adm-header-title">Admin Dashboard</h1>
            <p className="adm-header-sub">Iyengar Yoga St. Petersburg</p>
          </div>
        </div>
        <a href="/" className="adm-back-link">← Back to site</a>
      </div>

      <div className="adm-tabs">
        {[
          { id: "bookings", label: "Bookings" },
          { id: "students", label: "Students & Passes" },
          { id: "calendar", label: "Calendar" },
          { id: "merch", label: "Merch" },
          { id: "reports",  label: "Reports" },
          { id: "checkin",  label: "Check-in" },
          { id: "settings", label: "Settings" },
        ].map(t => (
          <button key={t.id} className={`adm-tab ${tab === t.id ? "active" : ""}`} onClick={() => setTab(t.id)}>
            {t.label}
          </button>
        ))}
      </div>

      {tab === "bookings" && <BookingsTab />}
      {tab === "students" && <StudentsPassesTab />}
      {tab === "calendar" && <CalendarTab />}
      {tab === "merch" && <MerchTab />}
      {tab === "reports"  && <ReportsTab />}
      {tab === "checkin"  && <CheckInTab />}
      {tab === "settings" && <SettingsTab />}
    </div>
  );
}